import api from 'data/api';

export const loadIO = api('GET /api/mobile/finance/io/:id');
export const approveIO = api('POST /api/mobile/finance/io/:id/approve');
export const rejectIO = api('POST /api/mobile/finance/io/:id/reject');
export const moreInfoIO = api('POST /api/mobile/finance/io/:id/moreinfo');
export const undoIO = api('POST /api/mobile/finance/io/:id/undo');

export const downloadAttachment = api('GET /api/mobile/finance/attachment/:id');

export const reasonsIO = api('GET /api/mobile/finance/lookups/io/reasons');
